<template>
	<div class="overlay-test">
		<div class="overlay-bg-test"></div>
		<h1 class="info-text">Versleep een puzzelstuk naar de juiste plek en laat los</h1>
        <!-- <span class="hand-icon hand-right"></span>
        <h3 class="hand-right-text">Druk op mij om naar<br /> de volgende foto te gaan1</h3> -->
        <!-- <span class="hand-icon hand-left"></span>
        <h3 class="hand-left-text">Beweeg heen en weer om <br />toen met nu te vergelijken!</h3> -->
		<OverlayButton text="OK!" />
		<div class="overlay-layer"></div>
	</div>
</template>

<script>
import OverlayButton from "@/components/overlay/OverlayButton.vue";

export default {
	name: "PuzzleOverlay",
	components: {
		OverlayButton
	}
};
</script>

<style scoped>
.overlay-test {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}

.overlay-bg-test {
	position: absolute;
	z-index: var(--global-z-index-overlay);
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: rgba(8, 35, 42, 0.85);
}

.overlay-items {
	position: relative;
	z-index: var(--global-z-index-overlay-items);
}

.overlay-info-test {
	position: relative;
	z-index: var(--global-z-index-overlay-info);
}

.info-text {
	font-size: 100px;
    z-index: var(--global-z-index-overlay-info);
    position: absolute;
    left: 0;
	right: 0;
	text-align: center;
    top: 250px;
    color: white;
}

.overlay-layer {
	position: absolute;
	z-index: var(--global-z-index-overlay-layer);
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}

</style>